import { Styles, generateClasses } from '@lsy-netline/netline-ui';

export const darkModeSelectorClasses = generateClasses('DarkModeSelector', ['root', 'label', 'item'] as const);

const styles: Styles = ({ theme: { palette, spacing } }) => ({
  [`&.${darkModeSelectorClasses.root}`]: {
    display: 'flex',
  },

  [`.${darkModeSelectorClasses.label}`]: {
    margin: spacing(1, 1, 0.5, 1),
    fontWeight: 600,
    fontSize: 14,
    color: palette.grey[900],
  },

  [`.${darkModeSelectorClasses.item}`]: {
    padding: spacing(0.5, 3),
    '&.Mui-disabled': {
      opacity: 'unset',
    },
  },
});

export default styles;
